// removed by extract-text-webpack-plugin
module.exports = {"Interests":"Interests__Interests___3uuM6","InterestsHeader":"Interests__InterestsHeader___2_ZQG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/Interests/Interests.css
// module id = 52
// module chunks = 0